module.exports = __webpack_public_path__ + "img/asset-group-library-item.70916a0b.png";